import { ChangeDetectionStrategy, Component, OnChanges, OnInit } from '@angular/core';
import { Questions } from '@shared/enums/questions.enum';
import { SliderLabel as SliderLabelService } from '@player/shared/services/slider-label.service';
import { FadeInOut } from '@shared/animations/fade-in-out.anim';
import { SliderNpsBaseComponent } from '@player/+survey/question/slider-nps/slider-nps-base.component';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { SliderThumb } from '@player/shared/components/slider-thumb/slider-thumb.component';
import { SliderImages } from '@player/shared/components/slider-images/slider-images.component';
import { SliderLabel } from '@player/shared/components/slider-label/slider-label.component';

@Component({
  selector: 'slider-e-nps',
  templateUrl: './slider-nps-base.component.html',
  styleUrls: ['../slider-abstract/slider-abstract.component.scss', './slider-nps-base.component.scss'],
  providers: [SliderLabelService],
  animations: [FadeInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AsyncPipe, NgStyle, SliderThumb, SliderLabel, SliderImages],
})
export class SliderENps extends SliderNpsBaseComponent implements OnInit, OnChanges {
  protected readonly questionType: Questions = Questions.SLIDER_NPS;
}
